import $ from "jquery";
import StateManager from "../scuba/StateManager";


class Gallery {
  constructor($el) {
    var self = this;
    self.$el = $el;
    self.$slides = $el.find(".js-gallery__slides").first();
    self.width = $el.width();
    self.n = self.$slides.find(".js-gallery__slide").length;
    self.i = 0;
    self.setIndex(0);

    $el.find(".js-gallery__right").on("click", function(e){
      $.proxy(self.setIndex, self)(self.i + 1);
      e.preventDefault();
    });
    $el.find(".js-gallery__left").on("click", function(e){
      $.proxy(self.setIndex, self)(self.i - 1);
      e.preventDefault();
    });
    $(window).on("resize", () => {
      self.reloadWidth();
    });
  }
  reloadWidth(){
    var self = this;
    self.width = self.$el.width();
    self.setIndex(self.i);
  }
  setIndex(i){
    var self = this;
    if(i < self.n && i >= 0){
      self.$slides.css("marginLeft", -i*self.width);
      self.i = i;

      if(i === self.n-1){
        self.$el.addClass("is-at-end");
      } else {
        self.$el.removeClass("is-at-end");
      }
      if(i === 0){
        self.$el.addClass("is-at-beginning");
      } else {
        self.$el.removeClass("is-at-beginning");
      }
    }
  }
}

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find(".js-gallery").each(function(i, el) {
        var gal = new Gallery($(el));
        $(el).data("gallery", gal);
    });
});


// WEBPACK FOOTER //
// ./scripts/components/Gallery.js